"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: user/verification-unauthenticated-service.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fuser%2Fverification-unauthenticated-service.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.VerificationUnauthenticatedServiceClient = exports.GetPayfoneRedirectUrlResponse = exports.GetPayfoneRedirectUrlRequest = exports.StartOnboardingResponse = exports.StartOnboardingRequest = void 0;
/* eslint-disable */
const rpc_1 = require("@getstep/proto-lib/rpc");
const session_1 = require("../auth/session");
const otp_delivery_method_1 = require("./otp-delivery-method");
const verification_method_1 = require("./verification-method");
const protobufPackage = 'com.step.user.proto';
function createBaseStartOnboardingRequest() {
    return {
        phoneNumber: '',
        otpDeliveryMethod: undefined,
        verificationMethod: undefined,
        loginFlow: undefined,
        sendOtpForUnrecognizedPhone: false,
    };
}
exports.StartOnboardingRequest = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.phoneNumber)) {
            message.phoneNumber = globalThis.String(object.phoneNumber);
        }
        if (isSet(object.otpDeliveryMethod)) {
            message.otpDeliveryMethod = otp_delivery_method_1.OtpDeliveryMethod.fromJSON(object.otpDeliveryMethod);
        }
        if (isSet(object.verificationMethod)) {
            message.verificationMethod = verification_method_1.VerificationMethod.fromJSON(object.verificationMethod);
        }
        if (isSet(object.loginFlow)) {
            message.loginFlow = (0, session_1.loginFlowFromJSON)(object.loginFlow);
        }
        if (isSet(object.sendOtpForUnrecognizedPhone)) {
            message.sendOtpForUnrecognizedPhone = globalThis.Boolean(object.sendOtpForUnrecognizedPhone);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.phoneNumber !== undefined && message.phoneNumber !== '') {
            obj.phoneNumber = message.phoneNumber;
        }
        if (message.otpDeliveryMethod !== undefined) {
            obj.otpDeliveryMethod = otp_delivery_method_1.OtpDeliveryMethod.toJSON(message.otpDeliveryMethod);
        }
        if (message.verificationMethod !== undefined) {
            obj.verificationMethod = verification_method_1.VerificationMethod.toJSON(message.verificationMethod);
        }
        if (message.loginFlow !== undefined) {
            obj.loginFlow = (0, session_1.loginFlowToJSON)(message.loginFlow);
        }
        if (message.sendOtpForUnrecognizedPhone !== undefined &&
            message.sendOtpForUnrecognizedPhone !== false) {
            obj.sendOtpForUnrecognizedPhone = message.sendOtpForUnrecognizedPhone;
        }
        return obj;
    },
    create(base) {
        return exports.StartOnboardingRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseStartOnboardingRequest();
        message.phoneNumber = object.phoneNumber ?? '';
        message.otpDeliveryMethod =
            (object.otpDeliveryMethod !== undefined && object.otpDeliveryMethod !== null)
                ? otp_delivery_method_1.OtpDeliveryMethod.fromPartial(object.otpDeliveryMethod)
                : undefined;
        message.verificationMethod =
            (object.verificationMethod !== undefined && object.verificationMethod !== null)
                ? verification_method_1.VerificationMethod.fromPartial(object.verificationMethod)
                : undefined;
        message.loginFlow = object.loginFlow ?? undefined;
        message.sendOtpForUnrecognizedPhone = object.sendOtpForUnrecognizedPhone ?? false;
        return message;
    },
};
function createBaseStartOnboardingResponse() {
    return { sessionId: '', sessionLifetimeMs: '0', autoLoginPassword: '' };
}
exports.StartOnboardingResponse = {
    fromJSON(object) {
        const message = {
            sessionId: isSet(object.sessionId) ? globalThis.String(object.sessionId) : '',
            sessionLifetimeMs: isSet(object.sessionLifetimeMs)
                ? globalThis.String(object.sessionLifetimeMs)
                : '0',
        };
        if (isSet(object.autoLoginPassword)) {
            message.autoLoginPassword = globalThis.String(object.autoLoginPassword);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.sessionId !== '') {
            obj.sessionId = message.sessionId;
        }
        if (message.sessionLifetimeMs !== '0') {
            obj.sessionLifetimeMs = message.sessionLifetimeMs;
        }
        if (message.autoLoginPassword !== undefined && message.autoLoginPassword !== '') {
            obj.autoLoginPassword = message.autoLoginPassword;
        }
        return obj;
    },
    create(base) {
        return exports.StartOnboardingResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseStartOnboardingResponse();
        message.sessionId = object.sessionId ?? '';
        message.sessionLifetimeMs = object.sessionLifetimeMs ?? '0';
        message.autoLoginPassword = object.autoLoginPassword ?? '';
        return message;
    },
};
function createBaseGetPayfoneRedirectUrlRequest() {
    return { deviceIp: '' };
}
exports.GetPayfoneRedirectUrlRequest = {
    fromJSON(object) {
        const message = {
            deviceIp: isSet(object.deviceIp) ? globalThis.String(object.deviceIp) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.deviceIp !== '') {
            obj.deviceIp = message.deviceIp;
        }
        return obj;
    },
    create(base) {
        return exports.GetPayfoneRedirectUrlRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetPayfoneRedirectUrlRequest();
        message.deviceIp = object.deviceIp ?? '';
        return message;
    },
};
function createBaseGetPayfoneRedirectUrlResponse() {
    return { redirectUrl: '' };
}
exports.GetPayfoneRedirectUrlResponse = {
    fromJSON(object) {
        const message = {
            redirectUrl: isSet(object.redirectUrl) ? globalThis.String(object.redirectUrl) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.redirectUrl !== '') {
            obj.redirectUrl = message.redirectUrl;
        }
        return obj;
    },
    create(base) {
        return exports.GetPayfoneRedirectUrlResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetPayfoneRedirectUrlResponse();
        message.redirectUrl = object.redirectUrl ?? '';
        return message;
    },
};
/**
 * Verification Unauthenticated Service API.
 *
 * Allows caller to start sign-up or recovery process by verifying a phone
 * number.
 */
class VerificationUnauthenticatedServiceClient {
    rpc;
    name = 'com.step.user.proto.VerificationUnauthenticatedService';
    type = rpc_1.ServiceType.UNAUTHENTICATED;
    path = '/user';
    methods = [{
            name: 'StartOnboarding',
            requestType: exports.StartOnboardingRequest,
            responseType: exports.StartOnboardingResponse,
            authenticationOptions: undefined,
        }, {
            name: 'GetPayfoneRedirectUrl',
            requestType: exports.GetPayfoneRedirectUrlRequest,
            responseType: exports.GetPayfoneRedirectUrlResponse,
            authenticationOptions: undefined,
        }];
    constructor(rpc) {
        this.rpc = rpc;
    }
    /**
     * Initiates sign-up or recovery.
     * If the specified alias is already linked and verified then we add phone
     * verification OTP to the existing account.
     *
     * If the specified alias is not linked to a user account then we create
     * a new user account and setup OTP to verify the alias.
     */
    startOnboarding(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[0],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Initiates Payfone instant verification flow for the client
     */
    getPayfoneRedirectUrl(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[1],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
}
exports.VerificationUnauthenticatedServiceClient = VerificationUnauthenticatedServiceClient;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=verification-unauthenticated-service.js.map